/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.9",
    versionName: "0.2.0-nightly.2026.1.9",
    versionChannel: "nightly",
    buildDate: "2026-01-09T00:07:46.642Z",
    commitHash: "2f7b3a6e66555193a5d9ea4aec2a3eb24c3232c0",
};
